var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({backgroundImage: _vm.backgroundImage, opacity: _vm.backgroundOpacity}),attrs:{"id":"background-holder"}})}
var staticRenderFns = []

export { render, staticRenderFns }